import LayoutBasic from "@/layout/LayoutBasic";
import LayoutEmpty from "@/layout/LayoutEmpty";
import PageConsulting from "@/page/PageConsulting";
import PageCustomerService from "@/page/PageCustomerService";
import PageDesign from "@/page/PageDesign";
import PageIntroduction from "@/page/PageIntroduction";
import PageLayerPopSample from "@/page/PageLayerPopSample";
import PageMain from "@/page/PageMain";
import PageNotFound from "@/page/PageNotFound";
import PagePersonalDataPolicy from "@/page/PagePersonalDataPolicy";
import PageSitemap from "@/page/PageSitemap";
import PageSwiperjs from "@/page/PageSwiperjs";
import PageTemplate from "@/page/PageTemplate";
import { Route, Routes } from "react-router-dom";
import PageLogistics from "./page/PageLogistics";

function routeSetting() {
  return (
    <Routes>
      <Route element={<LayoutBasic/>}>
        <Route path="/" element={<PageMain title='메인'/>}/>
        <Route path="/PageIntroduction" element={<PageIntroduction title='이커머스 솔루션 소개'/>}/>
        <Route path="/PageDesign" element={<PageDesign title='디자인'/>}/>
        <Route path="/PageLogistics" element={<PageLogistics title='통합물류 솔루션'/>}/>
        <Route path="/PageCustomerService" element={<PageCustomerService title='고객센터'/>}/>
        <Route path="/PageConsulting" element={<PageConsulting title='컨설팅'/>}/>
        <Route path="/PageTemplate" element={<PageTemplate title='UI 템플릿'/>}/>
        <Route path="/PagePersonalDataPolicy" element={<PagePersonalDataPolicy title='개인정보처리방침'/>}/>
      </Route>
      <Route element={<LayoutEmpty/>}>
        <Route path="/PageSwiperjs" element={<PageSwiperjs title='swiperjs 샘플'/>}/>
        <Route path="/PageLayerPopSample" element={<PageLayerPopSample title='레이어 팝업 샘플'/>}/>
        <Route path="/PageSitemap" element={<PageSitemap title='사이트맵'/>}/>
      </Route>
      {/* 빈 레이아웃 */}
      <Route>
        <Route path="*" element={<PageNotFound title='페이지 404'/>}/>
      </Route>
    </Routes>
  );
}

export default routeSetting;